import { render, staticRenderFns } from "./WrongList.vue?vue&type=template&id=75fa64af&scoped=true"
import script from "./WrongList.vue?vue&type=script&lang=js"
export * from "./WrongList.vue?vue&type=script&lang=js"
import style0 from "./WrongList.vue?vue&type=style&index=0&id=75fa64af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fa64af",
  null
  
)

export default component.exports